
import AudioPlayer from 'components/voice-interaction/AudioPlayer';
import Transcript from 'components/voice-interaction/Transcript';
import Summary from 'components/voice-interaction/Summary';
import Classification from 'components/voice-interaction/Classification';
import NER from 'components/voice-interaction/NER';
import { get_all_black_listed_word, get_audio_history_by_id, get_voice_interaction_sentiment } from 'services/voiceInteractionService';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { handleLoader, handleVoice, handleVoiceAudioTime, setAudioExtract, setAudioSentiment } from 'redux/counterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { copyIcon } from 'assets/icons';
import { navClose } from '../../assets/icons';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';

const moment = require('moment');

const VoiceInteraction = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const wavesurferRef2: any = useRef();
    const voiceId = useSelector((state: any) => state.persistent.voiceId);
    const audioExtract = useSelector((state: any) => state.counter.audioExtract);
    const audioSentiment = useSelector((state: any) => state.counter.audioSentiment);
    const voiceCalled = useSelector((state: any) => state.counter.voiceCalled);
    const [blackListedWords, setBlackListedWords] = useState<string[]>([]);
    const [perviousValue, setPerviousValue] = useState<string>("");
    const [nextValue, setNextValue] = useState<string>("");
    const [isPlaying, setIsPlaying] = useState<boolean>(false);

    const getSentiment = async (id: string | undefined) => {
        try {
            const { result, error } = await get_voice_interaction_sentiment(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            dispatch(setAudioSentiment(result));
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const getAudioExtraction = async (id: string | undefined) => {
        try {
            const { result, error } = await get_audio_history_by_id(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            // dispatch(handleLoader(false));
            dispatch(setAudioExtract(result));
        } catch (error: any) {
            // dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const getBlacklistedWords = async () => {
        try {
            const { result, error } = await get_all_black_listed_word()
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result?.error
            }
            // dispatch(handleLoader(false));
            setBlackListedWords(result)
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleClick = async (id: string | undefined) => {
        dispatch(handleLoader(true));
        await getSentiment(id);
        await getAudioExtraction(id);
        await getBlacklistedWords();
        setIsPlaying(false);
        wavesurferRef2?.current?.pause();
        wavesurferRef2.current.seekTo(0);
        dispatch(handleLoader(false));
    }

    //Handle copy button
    const handleCopy = (text: string) => {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        try {
            document.execCommand('copy');
            // setCopySuccess('Text copied to clipboard using fallback method');
            // console.log('Text copied to clipboard using fallback method');
        } catch (error) {
            console.error('Error copying text with fallback method:', error);
            // setCopySuccess('Failed to copy text');
        }
        document.body.removeChild(textArea);
    };
    const confirm1 = (event: any) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Text Copied',
        });
    };

    const emotionClass = (emo: string) => {
        if (emo === "joy") {
            return (<span className="joy emotion fw-medium">
                Emotion: Joy
            </span>)

        } else if (emo === "sadness") {
            return <span className="sad emotion fw-medium">
                Emotion: Sadness
            </span>

        } else if (emo === "anger") {
            return <span className="anger emotion fw-medium">
                Emotion: Anger
            </span>

        } else if (emo === "fear") {
            return <span className="fear emotion fw-medium">
                Emotion: Fear
            </span>

        } else if (emo === "love") {
            return <span className="love emotion fw-medium">
                Emotion: Love
            </span>

        } else if (emo === "neutral") {
            return <span className="surprise emotion fw-medium">
                Emotion: Neutral
            </span>
        }
    }

    useEffect(() => {
        if (params.id !== "") {
            if (!voiceCalled) {
                handleClick(params.id)
            } else {
                dispatch(handleVoice(false));
                getBlacklistedWords();
            }
            dispatch(handleVoiceAudioTime("00:00.00"))
            const currentValue = params.id
            // Find the index of the current value
            const currentIndex = voiceId.indexOf(currentValue);
            // Get the previous and next values
            setPerviousValue(currentIndex > 0 ? voiceId[currentIndex - 1] : null);
            setNextValue(currentIndex < voiceId.length - 1 ? voiceId[currentIndex + 1] : null);

        } else {
            navigate(`/voice`)
        }
    }, [params.id])

    useEffect(() => {
        setIsPlaying(false);
        wavesurferRef2?.current?.pause();
        wavesurferRef2?.current?.seekTo(0);
    }, [voiceCalled])

    const cross_sellUpsellFunc = (selling: any) => {
        if (selling.transcription.selling.upsell) {
            return (
                <div className='inner-col'>
                    <h5>Opportunities:</h5>
                    <span className='cross-up-tag'>Upsell</span>
                </div>
            )
        }
        else if (selling?.transcription?.selling?.cross_sell) {
            return (
                <div className='inner-col'>
                    <h5>Opportunities:</h5>
                    <span className='cross-up-tag'>Crosssell</span>
                </div>
            )
        } else {
            return "";
        }
        return ""
    }

    return (
        <>
            {audioExtract !== "" && <>
                <div className='p-4 content-wrapper'>
                    {Object.keys(audioExtract)?.length !== 0 &&
                        <>
                            <div className='row d-flex flex-wrap voice-top-header'>
                                <div className='col-lg-8 col-sm-12'>
                                    <div className='d-flex align-items-center flex-wrap voicesidebar-head'>
                                        <span className='fw-file-nm'>
                                            {audioExtract?.audio_filename}
                                        </span>
                                        <span className='fw-file-date-time'><span>(</span>{moment(audioExtract?.created_at).format("Do MMMM YYYY - h:mm:ss a")}<span>)</span></span>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-12'>
                                    <div className='navigation-page-wrap'>
                                        <div className='navigate-page'>
                                            <span className={`nav-prev-btn ${perviousValue === null && 'disabled'}`} onClick={() => { if (perviousValue !== null) { navigate(`/voice/${perviousValue}`); wavesurferRef2?.current?.pause(); wavesurferRef2?.current?.seekTo(0); } }}><i></i>Previous</span>
                                            <span className={`nav-next-btn ${nextValue === null && 'disabled'}`} onClick={() => { if (nextValue !== null) { navigate(`/voice/${nextValue}`); wavesurferRef2?.current?.pause(); wavesurferRef2?.current?.seekTo(0); } }}>Next<i></i></span>
                                        </div>
                                        <div className='close-page' onClick={() => navigate(`/voice`)}>
                                            <img src={navClose} alt="nav-close" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row d-flex flex-wrap'>
                                <div className='col-lg-8 col-sm-12'>
                                    <div>
                                        <AudioPlayer wavesurferRef2={wavesurferRef2} audioSrc={audioExtract?.file_data} isPlaying={isPlaying} setIsPlaying={setIsPlaying} />
                                        <div className="row mb-0">
                                            <div className="col-lg-4 col-md-12">
                                                <div className="card p-0 voice-card">
                                                    <div className="card-body p-0">
                                                        <div className='voicesidebar-left-nav'>
                                                            <h5>Summary</h5>
                                                            <i onClick={(e) => { handleCopy(audioExtract?.is_summarization_content); confirm1(e) }}><img data-tooltip-id="my-tooltip" data-tooltip-content="Copy" src={copyIcon} alt="copy-button" /></i>
                                                        </div>
                                                        <Summary summarization={audioExtract?.is_summarization_content} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="card p-0 voice-card">
                                                    <div className="card-body p-0">
                                                        <div className='voicesidebar-left-nav'>
                                                            <h5>Classification</h5>
                                                            <i onClick={(e) => { handleCopy(audioExtract?.is_classification_content); confirm1(e) }}><img data-tooltip-id="my-tooltip" data-tooltip-content="Copy" src={copyIcon} alt="copy-button" /></i>
                                                        </div>
                                                        <Classification isClassification={audioExtract?.is_classification_content} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-4 col-md-12">
                                                <div className="card p-0 voice-card">
                                                    <div className="card-body p-0">
                                                        <div className='voicesidebar-left-nav'>
                                                            <h5>Entities</h5>
                                                            <i onClick={(e) => { handleCopy(audioExtract?.is_ner_content); confirm1(e) }}><img data-tooltip-id="my-tooltip" data-tooltip-content="Copy" src={copyIcon} alt="copy-button" /></i>
                                                        </div>
                                                        <NER isNer={audioExtract?.is_ner_content} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-12'>

                                    <div className='top-row-emotions'>
                                        <div className='first-col'>
                                            <h5>Sentiment:</h5>
                                            <ul className='sentiment-list'>
                                                <li>
                                                    <span className='joy-text'>Positive</span>
                                                </li>
                                                <li>
                                                    <span className='anger-text'>Negative</span>
                                                </li>
                                                <li>
                                                    <span className='natural-text'>Neutral</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className='second-col'>
                                            {cross_sellUpsellFunc(audioSentiment)}
                                            {/* <div className={`inner-col ${(audioSentiment?.transcription.usersTranscript?.selling.upsell || audioSentiment?.transcription.usersTranscript?.selling.cross_sell) ? "visible" : "invisible"}`}>
                                            <h5>Opportunities:</h5>
                                            <span className='emotion natural fw-medium'>{audioSentiment?.transcription.usersTranscript?.selling.cross_sell || audioSentiment?.transcription.usersTranscript?.selling.upsell}</span>
                                        </div> */}
                                            {audioSentiment.is_black_list_word === "yes" &&
                                                <div className='inner-col'>
                                                    <h5>Words:</h5>
                                                    <span className='black-listed-word'>Black Listed</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    <div className="card card-transcript">
                                        <div className="card-body p-0">
                                            <div className="voicesidebar-left-nav">
                                                <h5>Transcript</h5>
                                                {emotionClass(audioSentiment?.transcription?.response.emotion)}
                                            </div>
                                            <Transcript usersTranscript={audioSentiment?.transcription} blackListedWords={blackListedWords} />
                                        </div>
                                    </div>
                                </div>
                                <ConfirmPopup
                                    content={({ message, hide }) =>
                                        <div className="bg-gray-900 border-round custom-tooltip">
                                            <span>{message}</span>
                                            <span className='d-none'>
                                                {setTimeout(() => {
                                                    hide()
                                                }, 2000) as any}
                                            </span>
                                        </div>
                                    }
                                />
                            </div>
                        </>
                    }
                </div>
            </>}
        </>

    )
}

export default VoiceInteraction